import * as React from "react";
import Button from "../button/button";
import i18n from "../../../../i18n/i18n";
import {ReactComponent as LoupeIcon} from "../../../../statics/icons/icon_loupe.svg";
import "./searchButton.scss";

interface SearchButtonProps {
    onClick: () => void;
    isWaiting: boolean;
}

export default function SearchButton(props: SearchButtonProps): React.ReactElement {
    return (
        <Button
            className="search"
            text={i18n.t("searchButton")}
            type="primary"
            variant="outlined"
            onClick={props.onClick}
            endIcon={<LoupeIcon/>}
            isWaiting={props.isWaiting}
            testId="search-btn"
        />
    );
}